import {startTransition} from 'react'

import {useMergeMethodContext} from '../contexts/MergeMethodContext'
import {useStackMergeabilityQuery} from '../page-data/loaders/use-stack-mergeability-page-data'
import {
  EMPTY_CHANNELS,
  useMergeabilityLiveUpdates,
  type MergeabilityLiveUpdateChannels,
} from '../hooks/use-mergeability-live-updates'

export function useStackMergeabilityUpdates({
  basePageDataUrl,
  channels,
}: {
  basePageDataUrl: string
  channels: MergeabilityLiveUpdateChannels | null
}) {
  const {mergeMethod} = useMergeMethodContext()
  const {refetch} = useStackMergeabilityQuery({basePageDataUrl, mergeMethod, enabled: false})
  useMergeabilityLiveUpdates({
    channels: channels ?? EMPTY_CHANNELS,
    refetchQuery: () => {
      startTransition(() => {
        refetch()
      })
    },
    throttleTime: 5000,
  })
}
